import { REGEX_DEVICE_MOBILE } from 'constants/common'

export const isMobile = () => {
	return REGEX_DEVICE_MOBILE.test(navigator.userAgent)
}
